import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import './styles/Metar.css'
import * as action from '../actions/actions'
import classnames from 'classnames'
import Vector from './Vector'

class Metar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      age: 0
    }
    this.ageInterval = undefined
    this.updateAge = this.updateAge.bind(this)
  }

  componentDidMount() {
    if(!this.props.metar.updatedAt) {
      this.props.updateMetar(this.props.icao)
    }
    if(this.props.metar.time) {
      this.updateAge()
    }
    this.ageInterval = setInterval(this.updateAge, 1000)
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      age: Math.round((new Date() - newProps.metar.time) / 60000)
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.age !== nextState.age ||
      this.props.metar.isFetching !== nextProps.metar.isFetching ||
      this.props.metar.error !== nextProps.metar.error
  }

  componentWillUnmount() {
    clearInterval(this.ageInterval)
  }

  render() {
    const metar = this.props.metar
    const metarTime = metar.isFetching || metar.error ? null : this.state.age + " minutes ago"
    const metarDetailLink = metar.isFetching || metar.error ? null : <Link to={"metars/" + metar.icao}>View Details</Link>

    if(metar.isFetching) {
      return (
        <div className={classnames("metar", {
          "metarLoading": true
        })}>
          <div className={"metarHeader tint"}>
            <div className={"metarHeaderLoading"}>
              {"Getting information from this station..."}
            </div>
          </div>
          <div className="metarBody">
            <Vector
              distance={metar.distance}
              bearing={metar.bearing}
            />
            <div className={"metarStation"}>
              <div className={"metarStationCode displayValue"}>
                {metar.icao}
              </div>
              <div className={"metarStationName subText"}>
                {metar.name}
              </div>
            </div>
          </div>
        </div>
      )
    }
    if(metar.error) {
      return (
        <div className={classnames("metar", {
          "metarLoadFailed": true
        })}>
          <div className={"metarHeader tint"}>
            <div className={"metarHeaderError"}>
              {"We couldn't get information from this station"}
            </div>
          </div>
          <div className="metarBody">
            <Vector
              distance={metar.distance}
              bearing={metar.bearing}
            />
            <div className={"metarStation"}>
              <div className={"metarStationCode displayValue"}>
                {metar.icao}
              </div>
              <div className={"metarStationName subText"}>
                {metar.name}
              </div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className={
        classnames('metar', {
          metarOutlookVFR: metar.flightRules === 'VFR',
          metarOutlookMVFR: metar.flightRules === 'MVFR',
          metarOutlookIFR: metar.flightRules === 'IFR',
          metarOutlookLIFR: metar.flightRules === 'LIFR'
        })
      }
      >
        <div className={"metarHeader tint"}>
          <span className={"metarOutlook subText"}>{metar.flightRules}&nbsp;</span>
          <span className={"metarTime subText"}>{metarTime}</span>
        </div>
        <div className={"metarBody"}>
          <Vector
            distance={metar.distance}
            bearing={metar.bearing}
          />
          <div className={"metarStation"}>
            <div className={"metarStationCode displayValue"}>
              {metar.icao}
            </div>
            <div className={"metarStationName subText"}>
              {metar.name}
            </div>
          </div>
        </div>
        <div className={"metarFooter tint"}>
          &nbsp;{metarDetailLink}&nbsp;
        </div>
      </div>
    )
  }

  updateAge() {
    if(this.props.metar.time) {
      this.setState({
        age: Math.round((new Date() - this.props.metar.time) / 60000)
      })
    }
  }
}


const mapDispatchToProps = dispatch => ({
  updateMetar: (icao) => dispatch(action.updateMetar(icao))
})

export default connect(
  null,
  mapDispatchToProps
)(Metar)



// WEBPACK FOOTER //
// ./src/components/Metar.js